<template>
  <div>
    <section class="course-area course-area4">
    <div class="course-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                  <div class="course-tab-wrap d-flex align-items-center">
                     <img src="/static/images/icon_cuoti.png" class="courses-showing-icon"/><span class="courses-showing-text">共有{{intTotal}}场考试记录</span>
                    </div><!-- end course-tab-wrap -->
                    
                </div><!-- end col-lg-12 -->
            </div><!-- end row -->
            <div class="row courses-search">
                <div class="col-lg-4">
                     <div class="course-filter d-flex align-items-center ml-auto">
                            <div class="courses-ordering">
                                <h3 class="widget__title">考试类型</h3>
                                <el-select v-model="searchType" placeholder="请选择考试类型">
                                    <el-option
                                    label="竞聘考试"
                                    value="exam">
                                    竞聘考试
                                    </el-option>
                                    <el-option
                                    label="模拟测试"
                                    value="test">
                                    模拟测试
                                    </el-option>
                                </el-select>
                            </div><!-- end courses-ordering -->
                        </div><!-- end course-filter -->
                </div>
                 <div class="col-lg-4">
                     <div class="sidebar-widget">
                            <h3 class="widget__title">搜索课程</h3>
                            <div class="contact-form-action">
                                <el-input
                                    placeholder="搜索课程"
                                    v-model="searchWords">
                                    <i slot="suffix" class="el-icon-search" @click="toPage(1)"></i>
                                </el-input>
                            </div><!-- end contact-form-action -->
                        </div><!-- end sidebar-widget -->
                </div>
                 <div class="col-lg-4">
                     <div class="course-filter d-flex align-items-center ml-auto">
                            <div class="courses-ordering">
                                <h3 class="widget__title">考试科目</h3>
                                <el-select v-model="searchSub" placeholder="所有科目">
                                    <el-option
                                    v-for="courcate in courcates"
                                    :key="courcate.name"
                                    :label="courcate.name"
                                    :value="courcate.name">
                                    </el-option>
                                </el-select>
                            </div><!-- end courses-ordering -->
                        </div><!-- end course-filter -->
                </div>
            </div>
        </div><!-- end container -->
    </div><!-- end course-wrapper -->
    <div class="course-content-wrapper">
        <div class="container">
            <div class="row course-item-wrap">
                <div class="col-lg-12">
                    <div class="tab-content">
                        <div role="tabpanel" class="tab-pane fade show active" id="tab2">
                            <div class="row course-block course-list-block">
                                <div class="col-lg-12" v-for="(exam,index) in exams" :key="index">
                                    <div class="course-item">
                                        <div class="course-content">
                                            <p :class="getExamState(exam).class">
                                                <span class="course__label">{{getExamState(exam).txt}}</span>
                                                <!-- <a href="#" class="course__collection-icon" data-toggle="tooltip" data-placement="top" title="Add to Wishlist"><span class="la la-heart-o"></span></a> -->
                                            </p>
                                            <h3 class="course__title">
                                                <a>{{exam.testPaper.title}}</a>
                                            </h3>
                                            <p class="course__author">
                                                <a>提交时间:{{!exam.etime?'无':exam.etime}}</a>
                                                <span class="meta__date">
                                                    得分/总分：<span style="color:red;">{{!exam.examAchieveMent?'0':exam.examAchieveMent.score}}</span>/{{exam.testPaper.totalscore}}
                                                </span>
                                            </p>
                                            <div class="rating-wrap d-flex">
                                                
                                                <span class="star-rating-wrap">
                                                    <span class="star__rating">{{exam.testPaper.examinee.join(",")}} &nbsp;&nbsp;&nbsp;</span>
                                                    <span class="star__count">{{exam.testPaper.papertype=='test'?'模拟测试':'竞聘考试'}}</span>
                                                </span>
                                            </div><!-- end rating-wrap -->
                                            <div class="course-meta">
                                                <ul class="course__list d-flex">
                                                    <li>
                                                        <span class="meta__date">
                                                             正确/错误：{{!exam.examAchieveMent?'0':exam.examAchieveMent.correct}}/{{!exam.examAchieveMent?'0':exam.examAchieveMent.error}}
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div><!-- end course-meta -->
                                            <div class="course-price-wrap">
                                                <span class="course__price"><i class="la la-clock-o"></i>耗时：{{!exam.ctime||!exam.etime?'00:00:00': getTimediff(exam.ctime.replace(/\./g,'/'), exam.etime.replace(/\./g,'/'))}}</span>
                                                <router-link class="course__btn" v-if="getExamState(exam).class!='course__label-text_error'" :to="`/achieveview/${exam._id}`">查看试卷</router-link>
                                                <router-link class="course__btn" style="color:red" v-else :to="global.isPhone()?`/exam/${exam.testpaperid}`:`/exampc/${exam.testpaperid}`">继续考试</router-link>
                                            </div><!-- end course-price-wrap -->
                                        </div><!-- end course-content -->
                                    </div><!-- end course-item -->
                                </div><!-- end col-lg-12 -->
                            </div>
                        </div>
                    </div><!-- end tab-content -->
                    <div class="pagination-wrap">
                        <nav aria-label="Page navigation">
                           <el-pagination
                            background
                            :page-size="6"
                            :hide-on-single-page="intTotal<=6"
                            layout="prev, pager, next"
                            @current-change="toPage"
                            @prev-click="toPage"
                            @next-click="toPage"
                            :total="intTotal">
                        </el-pagination>
                        </nav>
                    </div><!-- end pagination-wrap -->
                </div><!-- end col-lg-8 -->
            </div><!-- end row -->
        </div><!-- end container -->
    </div><!-- end course-content-wrapper -->
</section><!-- end courses-area -->
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data () {
    return {
        global,
        intTotal:20,
        intCurrent:1,
        exams:[],
        plateId:"",
        searchType:"",
        paperSubs:[],
        searchWords:"",
        searchSub:""
    };
  },

  components: {},

  computed: {
      
  },
  watch:{
      searchType(newVal){
          if(newVal)
          {
              this.toPage(0);
          }
      }
  },
  mounted() {
    this.$axios.get(`/api/examRecords?page=1&limit=6&sort=-createdAt`).then(res => {
        if(res.data)
        {
            this.exams=res.data.data;
            this.intTotal = res.data.total;
        }
    });
    this.$axios.get("/api/auth/me").then(res => {
            let arrhasCourse = [];
            for (var i = 0; i <res.data.data.needexaminee.length; i++)
            {
              arrhasCourse.push(res.data.data.needexaminee[i].coursetype);
            }
            this.paperSubs = arrhasCourse;
        })
  },

  methods: {
      toTop(){
        document.body.scrollTop =0;
        document.documentElement.scrollTop = 0;
      },
      setSearchSubs(searchSub){
          this.searchSub = searchSub;
      },
      toPage(intcount){
        if(intcount)this.intCurrent = intcount;
        var searchConditions = "";
        if(this.searchType)
        {
          searchConditions+="&testpapertype="+this.searchType;
        }
        if(this.searchWords)
        {
          searchConditions+="&testpapertitle=$regex:"+this.searchWords;
        }
        if(this.searchSub){
          searchConditions+="&testpaperexaminee="+this.searchSub;
        }
        this.$axios.get(`/api/examRecords?page=${this.intCurrent}&limit=6&sort=-createdAt${searchConditions}`).then((res) => {
            if (res.data) {
                this.intTotal =res.data.total;
                this.exams = res.data.data;
                 this.toTop();
            }
        });
      },
      getTimediff(starttime, endtime){
            console.log(starttime)
            let start = new Date(starttime);
            let end = new Date(endtime);
            let time = end - start;
            console.log(time);
            //计算出相差天数
            var days=Math.floor(time/(24*3600*1000))
            
            //计算出小时数

            var leave1=time%(24*3600*1000)    //计算天数后剩余的毫秒数
            var hours=Math.floor(leave1/(3600*1000))
            //计算相差分钟数
            var leave2=leave1%(3600*1000)        //计算小时数后剩余的毫秒数
            var minutes=Math.floor(leave2/(60*1000))
            //计算相差秒数
            var leave3=leave2%(60*1000)      //计算分钟数后剩余的毫秒数
            var seconds=Math.round(leave3/1000)
            return `${('00'+hours).slice(-2)}:${('00'+minutes).slice(-2)}:${('00'+seconds).slice(-2)}`
        },
      dateFormat(date, format){
            var o = {
            "M+" : date.getMonth()+1, //month
            "d+" : date.getDate(), //day
            "h+" : date.getHours(), //hour 24
            "H+" : date.getHours(), //hour 24
            "m+" : date.getMinutes(), //minute
            "s+" : date.getSeconds(), //second
            "q+" : Math.floor((date.getMonth()+3)/3), //quarter
            "S" : date.getMilliseconds() //millisecond
            };

            if(/(y+)/.test(format)) {
            format = format.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
            }

            for(var k in o) {
                if(new RegExp("("+ k +")").test(format)) {
                    format = format.replace(RegExp.$1, RegExp.$1.length==1 ? o[k] : ("00"+ o[k]).substr((""+ o[k]).length));
                }
            }
            return format;
        },
        getExamTimes(times){
            switch(times)
            {
                case "0":
                    return "不可补考";
                case "1":
                    return "可补考一次";
                case "2":
                    return "不限次数"
            }
        },
         NewDate(str){ 
            if(!str){
                return 0;
            }
            let arr=str.split(" ");
            let d=arr[0].split("-");
            let t=arr[1].split(":");
            var date = new Date();
            date.setUTCFullYear(d[0], d[1] - 1, d[2]);
            date.setUTCHours(t[0], t[1], t[2], 0);
            return date;
        },
        getExamState(exam){
            var objrecord ={};
            switch(exam.state) {
                case "complete":
                    if(exam.examAchieveMent)
                    {
                        objrecord.txt = "完成";
                        objrecord.class = "course__label-text";
                    }else{
                        objrecord.txt = "待批改";
                        objrecord.class = "course__label-text_warning"
                    }
                    break;
                case "fail":
                    objrecord.txt = "未提交";
                    objrecord.class = "course__label-text_failed"
                    break;
                case "edit":
                    objrecord.txt = "正在进行";
                    objrecord.class = "course__label-text_error"
                    break;
                default:
                    objrecord.txt = "未提交";
                    objrecord.class = "course__label-text_failed"
                    break;
            }
            return objrecord;
        },
  }
}

</script>
<style scoped>
/deep/ .el-input__inner{
	height: 61px;
    line-height: 61px;
    width:368.8px;
    margin-top:15px;
    font-size: 16px;
}
/deep/ .el-input__suffix{
     margin-top:15px;
     height: 61px;
   
}
/deep/ .el-select .el-input .el-select__caret{
  color: #4282CAFF;
    font-size: 23px;
    font-weight: 600;
}
.el-icon-search{
        line-height: 61px;
    font-size: 21px;
    margin-right: 10px;
}
/deep/ .el-radio{
    margin-right: 41px;
    margin-left: 27px;
}
/deep/ .el-radio__label{
    font-size:16px;
    /* font-weight: 600; */
}
/deep/ .el-radio__inner{
        border: 2px solid #4485CCFF;
}

.course-wrapper{
	width: 1198px;
	height: 224px;
	background: #ffffff66;
	box-shadow: 0px 6px 17px 1px rgba(68, 133, 204, 0.27);
	border-radius: 5px;
	margin: auto;
	padding: 15px;
}
.course-content{
    width: 1200px;
height: 294px;
background: #FFFFFF;
box-shadow: 0px 0px 40px 0px rgba(68, 133, 204, 0.27);
border-radius: 5px;
}
.course-item {
width: 1200px;
height: 294px;
margin-bottom: 40px;
}
.course-content{
    border: none;
}
.course__label{
      position: absolute;
    top: -10px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;  
}
.course__label-text{
     width: 0;
    height: 0;
    border-top: 50px solid #62C485;
    border-right: 80px solid transparent;
}
.course__label-text_failed{
     width: 0;
    height: 0;
    border-top: 50px solid #a5a5a5;
    border-right: 80px solid transparent;
}
.course__label-text_error{
     width: 0;
    height: 0;
    border-top: 50px solid #ff0000;
    border-right: 80px solid transparent;
}
.course__label-text_warning{
     width: 0;
    height: 0;
    border-top: 50px solid #ff9900;
    border-right: 80px solid transparent;
}
.course__title{
    margin-top:0px;
}
.course__title a{
    margin-left: 44px;
}
.course__author{
        margin-left: 44px;
}
.star-rating-wrap{
        left: 44px;
}
.course-meta li{
        margin-left: 44px;
}
.course-block .course-item .course-content .course-price-wrap .course__price{
        margin-left: 39px;
     font-weight: 500;
}
.meta__date{
        float: right;
    font-size: 20px;
    color: #313F57;
}
.course__author{
    padding-right: 36px;
}
.course__btn{
    float: right;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #59BF7B;
}
.course-price-wrap{
    padding-right: 36px;
}
.course-price-wrap a{
    text-decoration: underline;
}    
</style>